import { ValidationResult } from '../../../../../../../../../ui/gzForm/formField/types/form-validator';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { ExchangeAntimalwareRuleFormValue } from '../../../../../../utils/uiSettings/exchange/exchange-protection.types';
import { ExchangeAntimalwareRule } from '@nirvana/shared/dtos/types/policies/common';

// validate duplicates
export function validateDuplicates(
  ruleItem: ExchangeAntimalwareRuleFormValue,
  rulesInGrid: ExchangeAntimalwareRule[]
): ValidationResult {
  const hasDuplicates = rulesInGrid.some((ruleInGrid: ExchangeAntimalwareRule) => ruleInGrid.name === ruleItem.name);

  if (hasDuplicates) {
    return {
      valid: false,
      error: translateFn('The entry already exists.'),
    };
  }

  return {
    valid: true,
  };
}
